import { render } from "./Base.vue?vue&type=template&id=63178cfb&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"

import "./Base.vue?vue&type=style&index=0&id=63178cfb&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63178cfb"]])

export default __exports__